import { ComponentDecisions, Decision } from '../structure';

import { TokenOptions } from './types';

const getValue = <V extends string>(
    tokens: ComponentDecisions<V>,
    tokenName: Decision,
    { variant, state }: TokenOptions<V> = {}
): string => {
    const token = tokens[tokenName];
    if (!token) {
        return '';
    }

    if (variant) {
        const variants = token.variant;
        if (variants) {
            const selectedVariant = variants[variant];

            if (selectedVariant) {
                if (!state) {
                    return selectedVariant.value;
                }

                const variantStates = selectedVariant.state;
                if (variantStates) {
                    const selectedState = variantStates[state];
                    if (selectedState) {
                        return selectedState.value;
                    }
                }
            }
        }
    }

    if (state) {
        const tokenStates = token.state;
        if (tokenStates) {
            const selectedState = tokenStates[state];
            if (selectedState) {
                return selectedState.value;
            }
        }
    }

    return token.value;
};

export default getValue;
